module.exports = __webpack_public_path__ + "img/938000323_4.8eb7f7c6.jpg";